<template>
  <div id="app">

    <!-- Simple header with fixed tabs. -->
    <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header mdl-layout--fixed-tabs">
      <header class="mdl-layout__header">
        <div class="mdl-layout__header-row">
          <!-- Title -->
          <span class="mdl-layout-title">Charging Ledger (demo)</span>
        </div>
        <!-- Tabs -->
        <div class="mdl-layout__tab-bar mdl-js-ripple-effect">
          <router-link to="/" href="#fixed-tab-1" class="mdl-layout__tab is-active">Home</router-link>
          <router-link to="/customer" href="#fixed-tab-2" class="mdl-layout__tab">Customer-side Dapp</router-link>
          <router-link to="/utility" href="#fixed-tab-3" class="mdl-layout__tab">Utility-side Dapp</router-link>
          <router-link to="/settings" href="#fixed-tab-1" class="mdl-layout__tab">Settings</router-link>
        </div>
      </header>
      <div class="mdl-layout__drawer">
        <span class="mdl-layout-title">Charging Ledger</span>
      </div>
      <main class="mdl-layout__content">
        <router-view/>
        
      </main>
    </div>

  </div>
</template>

<script>

export default {
  name: 'App',

  mounted () {
    // console.log('registerWeb3 Action dispatched from App.vue')
    // this.$store.dispatch('registerWeb3')
  },

}
</script>

<style>
#app {

}
</style>



// WEBPACK FOOTER //
// src/App.vue